import React, { useState } from "react";
import axios from "axios";
import "./NewEventModal.css";

const EventForm = () => {
  const apiUrl = process.env.REACT_APP_API_URL;

  const [formData, setFormData] = useState({
    title: "",
    imageUrl: "",
    date: "",
    registrationLink: "",
    description: "",
    videoUrl: "", // ✅ Optional video URL
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${apiUrl}/events`, formData); // POST to your backend
      alert("Event added successfully!");
      setFormData({
        title: "",
        imageUrl: "",
        date: "",
        registrationLink: "",
        description: "",
        videoUrl: "", // ✅ Clear video URL after submission
      });
    } catch (error) {
      console.error("Error posting event:", error.response?.data || error.message);
      alert("Failed to add event.");
    }
  };

  return (
    <div className="full-screen-form">
      <h2>Add New Event</h2>
      <form onSubmit={handleSubmit} className="form">
        <input
          type="text"
          name="title"
          placeholder="Title"
          required
          value={formData.title}
          onChange={handleChange}
        />
        <input
          type="text"
          name="imageUrl"
          placeholder="Image URL"
          required
          value={formData.imageUrl}
          onChange={handleChange}
        />
        <input
          type="datetime-local"
          name="date"
          required
          value={formData.date}
          onChange={handleChange}
        />
        <input
          type="text"
          name="registrationLink"
          placeholder="Registration Link"
          required
          value={formData.registrationLink}
          onChange={handleChange}
        />
        <textarea
          name="description"
          placeholder="Description"
          required
          value={formData.description}
          onChange={handleChange}
        />
        <input
          type="text"
          name="videoUrl"
          placeholder="YouTube/Vimeo Video URL (optional)"
          value={formData.videoUrl}
          onChange={handleChange}
        />
        <button type="submit">Save Event</button>
      </form>
    </div>
  );
};

export default EventForm;
